'use client';

import { Toaster } from 'react-hot-toast';
import { useTheme } from '@/components/theme-provider';

/**
 * Тосты — тёмная горизонтальная капсула (Dodo snackbar-inspired).
 * Success/error отличаются цветом иконки, фон остаётся тёмным.
 */
export function ToastProvider() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const capsuleBg = isDark ? '#2c2c2e' : '#1c1c1e';
  const capsuleFg = '#ffffff';
  const capsuleShadow = isDark
    ? '0 10px 28px rgba(0, 0, 0, 0.45)'
    : '0 12px 28px rgba(15, 23, 42, 0.22)';

  return (
    <Toaster
      position="bottom-center"
      containerStyle={{
        bottom:
          'calc(env(safe-area-inset-bottom, 0px) + var(--pwa-bottom-nav-height, 76px) + var(--pwa-bottom-nav-lift, 0px) + 8px)',
        top: 'auto',
      }}
      toastOptions={{
        duration: 2500,
        style: {
          borderRadius: '9999px',
          padding: '12px 18px',
          fontSize: '14px',
          fontWeight: 500,
          maxWidth: 'min(380px, calc(100vw - 32px))',
          background: capsuleBg,
          color: capsuleFg,
          border: 'none',
          boxShadow: capsuleShadow,
        },
        success: {
          style: {
            background: capsuleBg,
            color: capsuleFg,
            border: 'none',
          },
          iconTheme: { primary: '#30d158', secondary: capsuleBg },
        },
        error: {
          style: {
            background: capsuleBg,
            color: capsuleFg,
            border: 'none',
          },
          iconTheme: { primary: '#ff453a', secondary: capsuleBg },
          duration: 2800,
        },
      }}
    />
  );
}
